/**
 * Coordinate convention:
 * - All page/cover element x/y represent the TOP-LEFT of the element's bounding box
 * - Units are millimeters unless explicitly marked as normalized (0–1) or points
 * - Rotation is degrees clockwise around the element center
 */
export const COORDINATE_ORIGIN = 'top-left' as const;
export const CURRENT_SCHEMA_VERSION = 1 as const;
export const APP_VERSION = '1.0.0';

export const MM_PER_INCH = 25.4;
export const POINTS_PER_INCH = 72;
